import React, { useEffect, useState } from "react";
import FooterNew from "../components/Footer-New";
import NavbarInner from "../components/Navbar-Inner.js";
import NavbarFixed from "../components/Navbar-Fixed.js";

// Images
import copy_icon from "../assets/images/copy_icon.svg";
import { Link, useNavigate, useParams } from "react-router-dom";

// import components
import Withdraw from '../components/Withdraw';
import isEmpty from "../lib/isEmpty.js";
import NavbarInnerSide from "../components/NavbarInnerSide.js";
import Sidebar from "../components/Sidebar.js";



export default function WithdrawPage(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { coin } = useParams();
  const history = useNavigate();
  useEffect(() => {
    if (isEmpty(coin)) {
      // history.push("/wallet");
    }
  }, [coin]);

  console.log(coin, 'coincoin')
  return (
    <div>
   
      {/* <NavbarInner /> */}
      <NavbarInnerSide toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <div className="flex w-full relative">
        <Sidebar isOpen={isSidebarOpen} closeSidebar={() => setIsSidebarOpen(false)} />
        <div className="flex-1 w-full overflow-hidden p-4">
          <Withdraw coin={coin} />
        </div>
      </div>
      {/* <FooterNew/> */}
      {/* <NavbarFixed /> */}
    </div>
  );
}
